
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import MRedeemableTokens from './MRedeemableTokens.vue';
import MRedemption from './MRedemption.vue';

@Options({
  components: {
    MRedemption,
    MRedeemableTokens
  }
})
export default class MCampaignPopup extends mixins(CampaignWidgetMixin) {
  show = false;

  get redemptionSuccessLabel() {
    return this.redemptionSuccessText ? this.redemptionSuccessText : 'Redemption Submitted';
  }

  async goBack() {
    this.clearActiveTokenAndRedemption();
    await this.updateState(true);
  }

  close() {
    this.$emit('close');
  }

  async mounted() {
    this.$nextTick(() => {
      // Travese the $el and its parents until we find the one with the data-widget="m-campaign" attribute
      const ancestor = this.$el.closest('[data-widget="m-campaign"]');

      // If the ancestor contains certain classes, add them to this.$el
      if (ancestor?.classList.contains('manifold-scheme-dark')) {
        this.$el.classList.add('manifold-scheme-dark');
      } else if (ancestor?.classList.contains('manifold-scheme-light')) {
        this.$el.classList.add('manifold-scheme-light');
      }

      document.body.appendChild(this.$el);

      setTimeout(() => {
        this.show = true;
      }, 250);
    });
  }

  // Note: Vue2 beforeDestroy() is now called beforeUnmount()
  async beforeUnmount() {
    // document.body.removeChild(this.$el);
    if (this.$el?.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
